import BaseEffectAction from './BaseEffectAction.js';
import {AUDIO_FX, MIDI_FX, LIVE_FX} from 'constants/effect-types.js';
import {initializeEffect} from 'components/effects/constants.js';

class DeleteEffectAction extends BaseEffectAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    execute({effect, track, group, send}) {
        let element = track || group || send;
        let effectJson = effect.getJson();
        switch (effect.getEffectType()) {
        case AUDIO_FX:
            element.effectsChain.deleteEffect(effect);
            break;
        case MIDI_FX:
            element.midiEffects.deleteEffect(effect);
            break;
        case LIVE_FX:
            element.liveEffects.deleteEffect(effect);
            break;
        }
        return {effectJson};
    }
}

export default DeleteEffectAction;
